import Link from 'next/link'
import BundleActions from 'components/BundleActions'
import BundleDescription from 'components/BundleDescription'
import BundleOccasionsList from 'components/BundleOccasionsList'
import Card from 'components/Card'
import CardContainer from 'components/CardContainer'
import BundleTitleRow from 'components/BundleTitleRow'
import { isUndefined } from 'lodash'
import { sortBySortOrder } from 'utilities/sort'
import { smartTruncate } from 'utilities/text'
import { Bundle } from '../../../api/src/bundles/bundle.entity'
import styles from './bundleOfferBrief.module.css'
import { getPackCountText } from 'utilities/bundles'

type Props = {
  bundle: Bundle,
  limitToOccasionIds?: number[],
  suppressDescription?: boolean,
  suppressLinks?: boolean,
  receiverId?: number,
}

const BundleOfferBrief = ({ bundle, limitToOccasionIds, suppressDescription = false, suppressLinks = false, receiverId }: Props) => {
  return <div className={styles.bundleOffer}>
    <BundleTitleRow
      title={
        suppressLinks
          ? bundle.title
          : <Link href={`/bundles/${bundle.slug}`}>
            <a className={styles.link}>{ bundle.title }</a>
          </Link>
      }
      subtitle={getPackCountText(bundle?.bundleCards?.length, limitToOccasionIds)}
      titleClassName={styles.title}
      secondary={
        suppressDescription
          ? <BundleActions bundle={bundle} limitToOccasionIds={limitToOccasionIds} suppressLink={suppressLinks} receiverId={receiverId} />
          : <BundleOccasionsList categoryTitles={ bundle.bundleCards.map(bundleCard => bundleCard.category.title) } />
      }
    />
    { !suppressDescription &&
      <BundleDescription>
        <div className={styles.description}>
          <div className={styles.descriptionBody} dangerouslySetInnerHTML={{ __html: bundle.description ? smartTruncate(bundle.description, 160) : '' }} />
          <Link href={`/bundles/${bundle.slug}`}>
            <a className={styles.viewMore}>
              <span className={styles.looksLikeALink}>more &raquo;</span>
            </a>
          </Link>
        </div>
        <BundleActions bundle={bundle} receiverId={receiverId} />
      </BundleDescription>
    }
    <div className={styles.bundleCards}>
      { bundle
        .bundleCards
        .sort(sortBySortOrder)
        .filter(bundleCard => isUndefined(limitToOccasionIds) || limitToOccasionIds.includes(bundleCard.categoryId))
        .map(bundleCard =>
          <div key={bundleCard?.id}>
            { bundleCard &&
              <div className={styles.cardContainer}>
                <CardContainer>
                  <Card card={bundleCard.card} size='medium' />
                </CardContainer>
                <div className={styles.cardOccasionLabel}>{ bundleCard.category.title }</div>
              </div>
            }
          </div>
        )
      }
    </div>
  </div>
}

export default BundleOfferBrief
